/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
const RedColor='#a81f00'

const DisplayCheckPriceComponent = (props) => {
  if (props.data.isBottomRow) {
  }
  return (
    <span
      className={`${
        (props.value !== null && parseFloat(props.value) < 0) ||
        props.data.isBottomRow
          ? 'semiBoldText'
          : 'regularText'
      }`}
      style={{
        color:
          props.value !== null && parseFloat(props.value) < 0 ? RedColor : '#000',
      }}
    >
      {props.value !== null
        ? parseFloat(props.value) < 0
          ? `(${(parseFloat(props.value) * -1).toFixed(2)})`
          : `${props.value}`
        : ''}
    </span>
  );
};

export default DisplayCheckPriceComponent;
